import{ useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { clearUser } from '../feature/user.Slice'; 

/**
 * @module Components/Stats
 * @description Stats est un composant qui affiche un tableau de statistiques des utilisateurs.
 * les statistiques affichées sont les suivantes:
 * - Nombre d'utilisateurs inscrits ce mois-ci
 * - Nombre d'utilisateurs inscrits et connectés ce mois-ci
 * - Nombre d'utilisateurs connectés ce mois-ci
 */


export default function Stats() {
    const apiPrefix = process.env.REACT_APP_API_PREFIX;
    const token = useSelector((state) => state.user.token);
    const [users, setUsers] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
    /**
     * Récupère la liste des utilisateurs
     */
      const fetchUsers = async () => {
          try {
              const response = await fetch(apiPrefix + 'users', {
                  method: 'GET',
                  headers: {
                      'Authorization': `Bearer ${token}`, 
                      'Content-Type': 'application/json',
                  },
              });

              if (!response.ok) {
                  dispatch(clearUser());
                  throw new Error('Erreur lors de la récupération des utilisateurs');
              }

              const data = await response.json();
              setUsers(data);
          } catch (error) {
              console.error('Erreur:', error);
          }
      };

      fetchUsers();
  }, [apiPrefix, token, dispatch]);
      
const date = new Date();
const currentMonth = date.getMonth();
const currentYear = date.getFullYear();


/**
 * Filtre les utilisateurs inscrits ce mois-ci
 */
const userConnectedThisMonth = users.filter((user) => {
    const lastActive = new Date(user.lastactive);
    return lastActive.getMonth() === currentMonth && lastActive.getFullYear() === currentYear;
})

/**
 * Filtre les utilisateurs inscrits et connectés ce mois-ci
 */
const userCreatedThisMonth = users.filter((user) => {
    const creationDate = new Date(user.creationDate);
    return creationDate.getMonth() === currentMonth && creationDate.getFullYear() === currentYear;
})

/**
 * Filtre les utilisateurs connectés ce mois-ci
 */
const createdActiveThisMonth = users.filter((user) => {
    const creationDate = new Date(user.creationDate);
    const lastActive = new Date(user.lastactive);
    return creationDate.getMonth() === currentMonth && creationDate.getFullYear() === currentYear && lastActive.getMonth() === currentMonth && lastActive.getFullYear() === currentYear;
})




      return (
        <div className="card">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">
                <i className="fas fa-chart-bar mr-2 text-primary"></i>
                Statistiques du mois
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-lg">
                    <div className="flex items-center">
                        <i className="fas fa-user-plus text-blue-500 text-2xl mr-3"></i>
                        <div>
                            <p className="text-sm text-gray-600">Inscriptions</p>
                            <p className="text-2xl font-bold text-blue-600">{userCreatedThisMonth.length}</p>
                        </div>
                    </div>
                </div>
                
                <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded-lg">
                    <div className="flex items-center">
                        <i className="fas fa-user-check text-green-500 text-2xl mr-3"></i>
                        <div>
                            <p className="text-sm text-gray-600">Inscrits & Connectés</p>
                            <p className="text-2xl font-bold text-green-600">{createdActiveThisMonth.length}</p>
                        </div>
                    </div>
                </div>
                
                <div className="bg-purple-50 border-l-4 border-purple-500 p-4 rounded-lg">
                    <div className="flex items-center">
                        <i className="fas fa-sign-in-alt text-purple-500 text-2xl mr-3"></i>
                        <div>
                            <p className="text-sm text-gray-600">Connexions</p>
                            <p className="text-2xl font-bold text-purple-600">{userConnectedThisMonth.length}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      );
}